import * as React from 'react';
import { Hr } from '@grandvisionhq/elements';

const DrawerDivider = ()=>/*#__PURE__*/ React.createElement(Hr, {
        className: "drawer-divider"
    })
;

export { DrawerDivider };
//# sourceMappingURL=DrawerDivider.js.map
